import { render, staticRenderFns } from "./SmallBookForm.vue?vue&type=template&id=8e37b0ea&"
import script from "./SmallBookForm.vue?vue&type=script&lang=js&"
export * from "./SmallBookForm.vue?vue&type=script&lang=js&"
import style0 from "./SmallBookForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports